import { largestCostChangesWidgetByIdSelector } from "./largestCostChangesWidgetByIdSelector";
import { RootState } from "../../../../store";
import { resourceExplorerViewsDataSelector } from "../../../../resource-explorer/selectors/all-resource-explorers/resourceExplorerViewsDataSelector";

export const largestCostChangesWidgetNotFoundSelector = (
  state: RootState,
  widgetId: string,
) => {
  const widget = largestCostChangesWidgetByIdSelector(state, widgetId);
  const views = resourceExplorerViewsDataSelector(state);

  if (!widget) {
    return false;
  }

  return !views.find((item) => item.id === widget.view_id);
};
